import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useMeter} from '../hooks/useMeter.ts';
import {useMetersSelection} from '../hooks/useMetersSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {id: meterId} = useParams();

    if (typeof meterId === 'undefined') {
        throw new Error('meterId is required parameter');
    }

    const {
        record: meter,
        loading,
        updateRecord,
    } = useMeter(meterId);

    const {handleClearSelection} = useMetersSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (loading || !meter) {
        return <PlatformLoader message='Loading meter...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={`Meter : ${meter.name ? meter.name : meter.id}`}
            pageNavigation={<EditPageNavigation component={meter}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile record={meter}/>
                </Stack>
                :
                <RecordForm
                    record={meter}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};